import { Box, Card, CardContent, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import Breadcrumbs from '../../../components/breadcrumbs'
import { getVendorInfo } from '../../../utils/constants'

export default function AboutUs() {
  const { VendorReducers: { selectedVendor } } = useSelector((state) => state)

  const { name: vendorName, key: vendorKey } = getVendorInfo(selectedVendor)

  // Annalakshmi's own About text, from the client (BCP Pitstop - Annalakshmi.pptx, October 2026)
  if (vendorKey === 'annalakshmi') {
    return (
      <>
        <Box p='30px'>
          <Breadcrumbs content={["About Us"]} />

          <Card sx={{ boxShadow: "0px 12px 23px rgba(62, 73, 84, 0.04)", borderRadius: "6px 6px 0px 0px", padding: { md: '20px', xs: '10px' }, mt: '30px' }}>
            <CardContent >
              <Typography variant='t24_600'>About Us</Typography>
            </CardContent>
            <CardContent>
              <Typography variant='t14_400'>
                Annalakshmi, located in four countries (India, Malaysia, Singapore and Australia), the vegetarian restaurant, leads the income generating quartet that sustains the artistic and charitable activities of the Temple of Fine Arts.
              </Typography>
            </CardContent>
            <CardContent>
              <Typography variant='t14_400'>
                Polished, private and yet utterly unpretentious, its success is the result of its underlying philosophy that is based on the ancient adage – atithi devo bhava – the guest is god.
              </Typography>
            </CardContent>
            <CardContent>
              <Typography variant='t14_400'>
                It is a philosophy that is manifested through the work of the largely voluntary staff – housewives who know what it takes to prepare a wholesome meal and a miscellaneous team of doctors, teachers, technicians, clerks and accountants who understand the meaning of polite, unobtrusive service.
              </Typography>
            </CardContent>
            <CardContent>
              <Typography variant='t14_400'>
                Annalakshmi stands out for yet another reason – the array of delectable dishes it serves in an ambience that reflects the ancient lore of Indian arts and culture. In every way then, it is a restaurant where vegetarian dining is a cultural experience.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </>
    )
  }

  return (
    <>
      <Box p='30px'>
        <Breadcrumbs content={["About Us"]} />

        <Card sx={{ boxShadow: "0px 12px 23px rgba(62, 73, 84, 0.04)", borderRadius: "6px 6px 0px 0px", padding: { md: '20px', xs: '10px' }, mt: '30px' }}>
          <CardContent >
            <Typography variant='t24_600'>About Us</Typography>
          </CardContent>
          <CardContent>
            <Typography variant='t14_400'>
              In India {vendorName} provides Catering and Support Services including extensive outdoor catering expertise to clients in a wide variety of sectors and marketplaces. Everyone in {vendorName} is committed to consistently delivering superior service in the most efficient way, for the shared benefit of our clients, customers, employees, and other stakeholders.
            </Typography>
          </CardContent>
          <CardContent>
            <Typography variant='t18_600'>Our Vision – </Typography>
            <Typography variant='t14_400'>
              sets out what we want to be To be a world-class provider of contract foodservice and support services , renowned for our great people, our great service, and our great results.
            </Typography>
          </CardContent>

          <CardContent>
            <Typography variant='t18_600'>Our Values – </Typography>
            <Typography variant='t14_400'>
              these set out what we collectively believe in and guide our behaviours ,can-do Safely, Responsibility, Win Through Teamwork, Passion for Quality, Openness, Trust and Integrity.
            </Typography>
          </CardContent>

          <CardContent>
            <Typography variant='t18_600'>Our Mission – </Typography>
            <Typography variant='t14_400'>
              sets out how we are going to achieve this Everyone in {vendorName} is committed to consistently delivering superior service in the most efficient way, for the shared benefit of our customers and employees.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  )
}
